import { Controller } from "@hotwired/stimulus"

// Prevents click events from bubbling up to parent elements
// Useful when you have interactive elements inside clickable containers
export default class extends Controller {
  click(event) {
    event.stopPropagation()
  }
}
